import { CLIENT_URL } from './constants.js';

export const campaignUrl = (name) => {
  if (!name) return;
  return `${CLIENT_URL}portal/${encodeURIComponent(name)}`;
};
